module.exports = __webpack_public_path__ + "img/jd1.099cede4.png";